// @flow

import React, { Component, Fragment } from 'react';
import {
  Card,
  PageBlock,
  Paragraph,
  Section,
  Strong,
  Text
} from 'seek-style-guide/react';
import { connect } from 'react-redux';
import styles from './SendJobPage.less';

import { sendJobToFriend } from 'src/store/jobdetails/jobdetails';

import SendJobForm from './SendJobForm/SendJobForm';
import FormContainer from 'src/components/FormContainer/FormContainer';
import StatusMessage from 'src/components/StatusMessage/StatusMessage';
import ReturnToJobLink from './ReturnToJobLink/ReturnToJobLink';

const mapDispatchToProps = {
  onSubmitSendJobForm: sendJobToFriend
};

type State = {
  submitted: boolean,
  submissionFailed: boolean,
  friendsName: string
};

type Props = {
  jobId: number,
  userName: string,
  userEmail: string,
  onSubmitSendJobForm: Function
};

class SendJobPage extends Component<Props, State> {
  static defaultProps = {
    userName: '',
    userEmail: ''
  };

  state = {
    submitted: false,
    submissionFailed: false,
    friendsName: ''
  };

  submitForm = formValues => {
    this.setState({ friendsName: formValues.receiverName });
    this.props
      .onSubmitSendJobForm(formValues)
      .then(() => {
        this.setState({
          submitted: true,
          submissionFailed: false
        });
      })
      .catch(() => {
        this.setState({
          submitted: true,
          submissionFailed: true
        });
      });
  };

  getSuccessRenderer = () => {
    const { friendsName } = this.state;
    const nameElement = <Strong>{friendsName}</Strong>;

    return (
      <Fragment>
        <Paragraph>
          <StatusMessage positive standard>
            Done! This job is on its way to {nameElement || 'your friend'}.
          </StatusMessage>
        </Paragraph>
        <ReturnToJobLink />
      </Fragment>
    );
  };

  render() {
    const { submitted, submissionFailed } = this.state;
    const { userName, userEmail } = this.props;

    const initialValues = {
      senderName: userName,
      senderEmail: userEmail,
      receiverName: '',
      receiverEmail: ''
    };

    return (
      <Fragment>
        <PageBlock>
          <Card className={styles.cappedWidth}>
            <Section>
              <Text headline>Send job</Text>
              <FormContainer
                showSuccess={submitted && !submissionFailed}
                successRenderer={this.getSuccessRenderer()}
                showError={submissionFailed}
                errorRenderer="There was a problem sharing this job"
              >
                <SendJobForm
                  jobId={this.props.jobId}
                  initialValues={initialValues}
                  submit={this.submitForm}
                  formErrorExists={submissionFailed}
                />
              </FormContainer>
            </Section>
          </Card>
        </PageBlock>
      </Fragment>
    );
  }
}

export default connect(
  null,
  mapDispatchToProps
)(SendJobPage);
